<script setup lang="ts">
</script>
<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 370.000000 36.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,36.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path d="M719 299 c-36 -5 -113 -20 -170 -35 -132 -33 -352 -43 -471 -22 l-78
14 0 -128 0 -128 1850 0 1850 0 0 139 0 139 -45 11 c-138 35 -221 24 -392 -51
-189 -82 -304 -95 -548 -59 -274 41 -404 37 -680 -19 -323 -65 -394 -63 -663
24 -222 72 -344 104 -451 116 -96 11 -109 11 -202 -1z" />
        </g>
    </svg>
</template>